import React from 'react'
import Head from 'next/head'

import Header from '@/partials/Header'
import Footer from '@/partials/FooterOLD2'
import TutorialsList from '@/partials/TutorialsList'
import Newsletter from '@/partials/Newsletter'
import YoutubeTutorialsList from '@/partials/YoutubeTutorialsList'
import TemplateNewsletter from '@/components/Templates/Index/TemplaeNewsletter'
import TemplatesList from '@/components/Templates/Index/TemaplatesList'
import { getSSRAuthKey } from 'constant/functions'
import { getUserDetails } from '../../api/api'
import { tradly_api_call } from '@/WebHandler/tradly_api_call'
import WorkspaceLayout from '@/layouts/WorkspaceLayout'
import TemplatesList2 from '@/components/Templates/Index/TemaplatesList2'
import { getCookie } from 'cookies-next'
import { auth_cookie_name } from 'constant/url'

function templates({ categories, templates, isLoggedIn }) {
  return (
    <>
      <Head>
        <meta
          key="twitter:title"
          name="twitter:title"
          content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
        />
        <meta
          key="og:title"
          property="og:title"
          content="Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
        />
        <title>Tradly – Templates</title>
      </Head>
      <WorkspaceLayout isLoggedIn={isLoggedIn}>
        <div className="flex flex-col min-h-screen overflow-hidden">
          {/*  Site header */}
          {/* <Header /> */}

          {/*  Page content */}
          <main className="flex-grow">
            {/*  Page sections */}
            <TemplatesList2 categories={categories?.categories} templates={templates} />
            {/* <TutorialsList /> */}

            <TemplateNewsletter />
          </main>
        </div>
      </WorkspaceLayout>
    </>
  )
}

export default templates

export async function getServerSideProps({ params, req, res, query }) {
  const { category_id, page } = query

  const categories = await tradly_api_call({
    method: 'GET',
    path: `/v1/categories`,
    params: {
      parent: 0,
      type: 'listings',
    },
    onSuccess: (res) => {
      return res?.categories
    },
    onError: (err) => {
      console.log(err)
      return {}
    },
  })

  let params_data = {
    page: page ? page : 1,
    category_id: 4045,
    type: 'listings',
    include: 'attributes',
    status: 2,
    sort: 'oldest_first',
  }
  if (category_id) {
    params_data.category_id = category_id
  }

  const templates = await tradly_api_call({
    method: 'GET',
    path: '/products/v1/listings',
    params: params_data,
    onSuccess: (res) => {
      return res?.listings
    },
    onError: (err) => {
      console.log(err)
      return {}
    },
  })
  const isLoggedIn = getCookie(auth_cookie_name, { req, res }) ? true : false

  return {
    props: { categories, templates, isLoggedIn }, // will be passed to the page component as props
  }
}
